import { Model } from "@vuex-orm/core";
import { required, maxLength } from "vuelidate/lib/validators";

export default class Manufacturer extends Model {
  static entity = 'manufacturers';

  static $fetch() {
    return this.api().get('Manufacturers/')
  }
  static $put (id, data) {
    return this.api().put(`Manufacturers/${id}/`, data)
  }
  static $post (data) {
    return this.api().post(`Manufacturers/`, data)
  }

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(""),
      icon: this.string("fas fa-industry"),
      hint: this.string("The original source of the material"),
      counter: this.number(64),
      label: this.string("Manufacturer")
    };
  }

  toCreatePayload() {
    return {
      name: this.name
    };
  }

  toUpdatePayload() {
    return {
      ...this.toCreatePayload(),
      id: this.$id
    };
  }

  static get validations() {
    return {
      formdata: {
        name: { required, maxLength: maxLength(64) }
      }
    };
  }
}
